import React from 'react';
import PropTypes from 'prop-types';
import {UncontrolledTooltip} from 'reactstrap';

let counter = 1;
const generateId = () => `tooltip-container-${counter++}`;

class TooltipContainerUnformatted extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: generateId(),
        };
    }

    render() {
        const {children, component, tooltip, ...props} = this.props;
        const Component = component || 'span';
        return (
            <Component id={this.state.id} {...props} className="tooltip-unformatted">
                {children}
                <UncontrolledTooltip target={this.state.id}>
                    {tooltip}
                </UncontrolledTooltip>
            </Component>
        );
    }
}

TooltipContainerUnformatted.propTypes = {
    children: PropTypes.node,
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    tooltip: PropTypes.string.isRequired,
};

export default TooltipContainerUnformatted;
